import LineOne from '@img/line-1.svg';
import LineTwo from '@img/line-2.svg'

const HeaderIcon = () => {
    return (
        <div className={ `header-icon`}>

               <img  className={`header-icon__first`} src={LineOne} alt="Line 1" />
                <img className={`header-icon__second`} src={LineTwo} alt="Line 2" />

                <div className="brand-logo">
                    <span className="brand-logo__mark">A</span>
                    <span className="brand-logo__text">AppWarehouse</span>
                </div>

        </div>
    )
}

export default HeaderIcon;